import { Container, Row } from "reactstrap";
import { Blog, BlogDetailsTitle } from "../../../../constants";
import BlogBoxGrid from "./BlogBoxGrid";
import BlogBoxList from "./BlogBoxList";
import BlogBoxShadow from "./BlogBoxShadow";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const BlogDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BlogDetailsTitle} parent={Blog} />
      <Container fluid>
        <Row>
          <BlogBoxShadow />
          <BlogBoxList />
          <BlogBoxGrid />
        </Row>
      </Container>
    </>
  );
};

export default BlogDetailsContainer;
